__turbopack_context__.v({
  "DM_12_24_Link_B": "SelectButton-module-scss-module__3erZxq__DM_12_24_Link_B",
  "DM_14_24_Link_B": "SelectButton-module-scss-module__3erZxq__DM_14_24_Link_B",
  "DM_20_24_Bold": "SelectButton-module-scss-module__3erZxq__DM_20_24_Bold",
  "DM_Body_Reg_16": "SelectButton-module-scss-module__3erZxq__DM_Body_Reg_16",
  "DM_Bold_14_16": "SelectButton-module-scss-module__3erZxq__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "SelectButton-module-scss-module__3erZxq__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "SelectButton-module-scss-module__3erZxq__DM_Bold_16_24",
  "DM_Bold_20_24": "SelectButton-module-scss-module__3erZxq__DM_Bold_20_24",
  "DM_Bold_40_56": "SelectButton-module-scss-module__3erZxq__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "SelectButton-module-scss-module__3erZxq__DM_Btn_16_16_Med",
  "DM_Med_10_12": "SelectButton-module-scss-module__3erZxq__DM_Med_10_12",
  "DM_Med_12_12_Chip": "SelectButton-module-scss-module__3erZxq__DM_Med_12_12_Chip",
  "DM_Med_12_16": "SelectButton-module-scss-module__3erZxq__DM_Med_12_16",
  "DM_Med_14_16": "SelectButton-module-scss-module__3erZxq__DM_Med_14_16",
  "DM_Med_14_20": "SelectButton-module-scss-module__3erZxq__DM_Med_14_20",
  "DM_Med_14_24": "SelectButton-module-scss-module__3erZxq__DM_Med_14_24",
  "DM_Med_16_16": "SelectButton-module-scss-module__3erZxq__DM_Med_16_16",
  "DM_Med_16_24": "SelectButton-module-scss-module__3erZxq__DM_Med_16_24",
  "DM_Med_18_24": "SelectButton-module-scss-module__3erZxq__DM_Med_18_24",
  "DM_Med_20_24": "SelectButton-module-scss-module__3erZxq__DM_Med_20_24",
  "DM_Med_24_24": "SelectButton-module-scss-module__3erZxq__DM_Med_24_24",
  "DM_Med_32_32": "SelectButton-module-scss-module__3erZxq__DM_Med_32_32",
  "DM_Med_32_48": "SelectButton-module-scss-module__3erZxq__DM_Med_32_48",
  "DM_Med_8_8": "SelectButton-module-scss-module__3erZxq__DM_Med_8_8",
  "DM_Reg_10_10": "SelectButton-module-scss-module__3erZxq__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "SelectButton-module-scss-module__3erZxq__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "SelectButton-module-scss-module__3erZxq__DM_Reg_12_16",
  "DM_Reg_14_16": "SelectButton-module-scss-module__3erZxq__DM_Reg_14_16",
  "DM_Reg_14_24": "SelectButton-module-scss-module__3erZxq__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "SelectButton-module-scss-module__3erZxq__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "SelectButton-module-scss-module__3erZxq__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "SelectButton-module-scss-module__3erZxq__DM_Reg_16_20",
  "DM_Reg_16_24": "SelectButton-module-scss-module__3erZxq__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "SelectButton-module-scss-module__3erZxq__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "SelectButton-module-scss-module__3erZxq__DM_Reg_18_28",
  "DM_Reg_32_32": "SelectButton-module-scss-module__3erZxq__DM_Reg_32_32",
  "DM_Reg_40_56": "SelectButton-module-scss-module__3erZxq__DM_Reg_40_56",
  "active": "SelectButton-module-scss-module__3erZxq__active",
  "buttonText": "SelectButton-module-scss-module__3erZxq__buttonText",
  "container": "SelectButton-module-scss-module__3erZxq__container",
  "error": "SelectButton-module-scss-module__3erZxq__error",
  "icon": "SelectButton-module-scss-module__3erZxq__icon",
  "minimal": "SelectButton-module-scss-module__3erZxq__minimal",
  "minimalIcon": "SelectButton-module-scss-module__3erZxq__minimalIcon",
  "opened": "SelectButton-module-scss-module__3erZxq__opened",
  "selectButton": "SelectButton-module-scss-module__3erZxq__selectButton",
  "tertiary": "SelectButton-module-scss-module__3erZxq__tertiary",
  "toggleIcon": "SelectButton-module-scss-module__3erZxq__toggleIcon",
});
